import { Component } from '@angular/core';

@Component({
  selector: 'app-change-password-success',
  templateUrl: './change-password-success.component.html',
  styleUrl: './change-password-success.component.scss',
  standalone: false
})
export class ChangePasswordSuccessComponent {

}
